function calculateShippingCosts(quantity, paymentMethod) {
    let shippingCosts = 2;

    if (paymentMethod === 'cashOnDelivery') {
        shippingCosts += 2.4;
    }

    return (quantity <= 2 ? shippingCosts : 0);
}

function normalizeDecimal(val, fractionDigits = 2) {
    return `${Number.parseFloat(val).toFixed(fractionDigits)}`.replace(/\./, ',');
}

function calculateTotalPrice(productPrice, quantityAsNumber) {
    const valueOfGoodsElement = document.querySelectorAll('.value_of_goods');
    const totalElement = document.querySelector('.total');
    const totalProductPrice = productPrice * quantityAsNumber;
    const paymentMethodElement = document.querySelector('[name="paymentMethod"]:checked');
    const shippingCostsElement = document.querySelector('.shipping_costs');
    const shippingCosts = calculateShippingCosts(quantityAsNumber, paymentMethodElement.value);
    const totalPrice = totalProductPrice + shippingCosts;

    valueOfGoodsElement.forEach(valueOfGood => valueOfGood.innerHTML = `${normalizeDecimal(totalProductPrice)} €`);
    shippingCostsElement.innerHTML = `${normalizeDecimal(shippingCosts)} €`;
    totalElement.innerHTML = `${normalizeDecimal(totalPrice)} €`;
}

function basket() {
    const productPrice = 15;
    const quantityElement = document.querySelector('#Form_OrderForm_Quantity');
    const paymentMethodElements = document.querySelectorAll('[name="paymentMethod"]');

    quantityElement.addEventListener('change', event => {
        const quantity = Number.parseInt(event.target.value);
        event.target.value = quantity;
        calculateTotalPrice(productPrice, quantity);
    });
    paymentMethodElements.forEach(
        paymentMethodElement => paymentMethodElement.addEventListener(
            'change',
            () => calculateTotalPrice(productPrice, Number.parseInt(quantityElement.value))
        )
    );
}

function deliveryAddress() {
    const deliveryAddressCheckbox = document.querySelector('.delivery-address-checkbox');
    const deliveryAddressContainer = document.querySelector('.delivery-address-container');

    deliveryAddressContainer.style.display = 'none';
    deliveryAddressCheckbox.addEventListener('change', (event) => {
        deliveryAddressContainer.style.display = (event.target.checked ? 'block': 'none');
    });
}

basket();
deliveryAddress();
